import React from 'react';
import I18n from 'i18n-js';

import RCIcon from './rc_icon';
import CloseSvg from '../../design-system/icons/core/close.svg';
import Tooltip from './tooltip';

interface IProps {
  handleClick: React.MouseEventHandler<HTMLButtonElement>
  'aria-label'?: string;
  tooltipText?: string;
}

export default function RCCloseButton(props: IProps) {
  const {
    handleClick,
    tooltipText,
  } = props;

  const ariaLabel = props['aria-label'] || I18n.t('commons.closeButton.defaultLabel');

  function onClick(event) {
    event.preventDefault();
    event.stopPropagation();
    handleClick(event);
  }

  const button = (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className="rc-close-button"
    >
      <RCIcon svgComponent={CloseSvg} />
    </button>
  );

  if (!tooltipText) {
    return button;
  }

  return (
    <Tooltip text={tooltipText} type="plain">
      {button}
    </Tooltip>
  );
}
